import React from 'react'

import { Container, ContainerAlert, ContainerContent } from './styles'
import { DynamicTable } from '~/components/shared/DynamicTable'
import { useMaternalInfantHealthProcedures } from '~/context'
import { useFetchNewbornScreening } from '~/hooks'
import { ENewbornScreeningTestCode, NewbornScreeningTestProperty } from '~/interfaces'

export const NeonatalScreening = (): JSX.Element => {
  const { selectedBaby } = useMaternalInfantHealthProcedures()
  const { data, isLoading, error } = useFetchNewbornScreening({ patientId: selectedBaby })

  const getNewbornTest = (testCodes: ENewbornScreeningTestCode[]): NewbornScreeningTestProperty[] => {
    const newbornTests = data?.filter(test => (test?.code ? testCodes.includes(test.code) : false))
    return newbornTests?.flatMap(test => test.properties) || []
  }

  if (error) {
    return (
      <ContainerAlert>
        <span>{error.message}</span>
      </ContainerAlert>
    )
  }

  return (
    <Container>
      <ContainerContent>
        <div>
          <DynamicTable
            content={getNewbornTest([
              ENewbornScreeningTestCode.HEEL_PRICK_TEST_CODE_1,
              ENewbornScreeningTestCode.HEEL_PRICK_TEST_CODE_2,
              ENewbornScreeningTestCode.HEEL_PRICK_TEST_CODE_3
            ])}
            headers={['Exame', 'Resultado', 'Valor de referência']}
            icon={'foot'}
            title={'Teste do Pezinho'}
            loading={isLoading}
          />
          <DynamicTable
            content={getNewbornTest([ENewbornScreeningTestCode.IMMUNO_ANALYSIS_CODE])}
            headers={['Propriedade', 'Resultado']}
            title={'Análise Imunohematológica do RN'}
            loading={isLoading}
          />
          <DynamicTable
            content={getNewbornTest([ENewbornScreeningTestCode.IMMUNODEFICIENCY_PANEL_CODE])}
            headers={['Propriedade', 'Interpretação do Resultado']}
            title={'Painel de Imunodeficiências primárias'}
            loading={isLoading}
          />
          <DynamicTable
            content={getNewbornTest([ENewbornScreeningTestCode.SMA_PANEL_CODE])}
            headers={['Propriedade', 'Interpretação do Resultado']}
            title={'Painel para Atrofia Muscular Espinhal'}
            loading={isLoading}
          />
          <DynamicTable
            content={getNewbornTest([ENewbornScreeningTestCode.QUALITATIVE_TANDEM_CODE])}
            headers={['Propriedade', 'Valor']}
            title={'Perfil Tandem - Avaliação Qualitativa'}
            loading={isLoading}
          />
          <DynamicTable
            content={getNewbornTest([ENewbornScreeningTestCode.QUANTITATIVE_TANDEM_CODE])}
            headers={['Propriedade', 'Interpretação do Resultado']}
            title={'Perfil Tandem - Avaliação Quantitativa'}
            loading={isLoading}
          />
        </div>
        <div>
          <DynamicTable
            content={getNewbornTest([
              ENewbornScreeningTestCode.PULSE_OXIMETRY_SCREENING_CODE,
              ENewbornScreeningTestCode.PULSE_OXIMETRY_SCREENING_CODE_1,
              ENewbornScreeningTestCode.PULSE_OXIMETRY_SCREENING_CODE_2,
              ENewbornScreeningTestCode.PULSE_OXIMETRY_SCREENING_CODE_3
            ])}
            headers={['Exame', 'Resultado']}
            icon={'heart'}
            title={'Teste do Coraçãozinho'}
            loading={isLoading}
          />
          <DynamicTable
            content={getNewbornTest([ENewbornScreeningTestCode.EYE_SCREENING_CODE])}
            headers={['Exame', 'Resultado', 'Valor de ref.']}
            icon={'eye'}
            title={'Teste do Olhinho'}
            loading={isLoading}
          />
          <DynamicTable
            content={getNewbornTest([ENewbornScreeningTestCode.HEARING_SCREENING_CODE])}
            headers={['Exame', 'Resultado', 'Valor de ref.']}
            icon={'ear'}
            title={'Teste da Orelhinha'}
            loading={isLoading}
          />
          <DynamicTable
            content={getNewbornTest([ENewbornScreeningTestCode.TONGUE_TEST_CODE])}
            headers={['Exame', 'Resultado']}
            icon={'tongue'}
            title={'Teste da Linguinha'}
            loading={isLoading}
          />
          <DynamicTable
            content={getNewbornTest([ENewbornScreeningTestCode.LYMPHOPENIAS_CODE])}
            headers={['Propriedade', 'Resultado', 'Valor de ref.']}
            title={'Pesquisa SCID, AGAMA e Linfopenias'}
            loading={isLoading}
          />
          <DynamicTable
            content={getNewbornTest([ENewbornScreeningTestCode.SOMMOS_DNA_TEST_CODE])}
            headers={['Propriedade', 'Interpretação do Resultado']}
            title={'SOMMOS Bebê'}
            loading={isLoading}
          />
          <DynamicTable
            content={getNewbornTest([ENewbornScreeningTestCode.SCIDS_CODE])}
            headers={['Propriedade', 'Resultado', 'Valor de ref.']}
            title={'SCIDs, Agamaglobulinemia'}
            loading={isLoading}
          />
          <DynamicTable
            content={getNewbornTest([ENewbornScreeningTestCode.LYSOSOMIC_SCREENING_CODE])}
            headers={['Propriedade', 'Resultado', 'Valor de ref.']}
            title={'Triagem Bioquímica Doenças Lisossômicas'}
            loading={isLoading}
          />
          <DynamicTable
            content={getNewbornTest([ENewbornScreeningTestCode.ELA_SCREENING_CODE])}
            headers={['Propriedade', 'Interpretação do Resultado']}
            title={'Triagem de Atrofia M.Espinhal (AME 5q)'}
            loading={isLoading}
          />
        </div>
      </ContainerContent>
    </Container>
  )
}
